import React, { useState } from 'react';
import api from '../api';
import { vehicleStatusConfig } from '../config';
import Loader from './Loader';

const VehicleOnboardingForm = ({ onVehicleAdded }) => {
  const [formData, setFormData] = useState({
    vehicle_no: '',
    chassis_number: '', // <-- ADDED
    motor_number: '',   // <-- ADDED
    hub_tag: '',
    make: '',
    model: '',
    status: 'Active',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api.post('/vehicles', formData);
      alert('Vehicle onboarded successfully!');
      if (onVehicleAdded) {
        onVehicleAdded();
      }
    } catch (error) {
      console.error(
        'Error onboarding vehicle:',
        error.response ? error.response.data : error.message,
      );
      alert(
        `Error: ${error.response ? error.response.data.message : error.message}`,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 p-6 bg-white dark:bg-gray-800 h-full overflow-y-auto"
    >
      {isSubmitting && <Loader />}
      <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
        Onboard New Vehicle
      </h2>

      <div className="space-y-4">
        <InputField
          label="Vehicle Number"
          name="vehicle_no"
          value={formData.vehicle_no}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Hub Tag"
          name="hub_tag"
          value={formData.hub_tag}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        {/* <InputField
          label="GPS Device ID"
          name="gps_device_id"
          value={formData.gps_device_id}
          onChange={handleChange}
        /> */}
        <InputField
          label="Chassis No"
          name="chassis_number"
          value={formData.chassis_number}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Motor No"
          name="motor_number"
          value={formData.motor_number}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Make"
          name="make"
          value={formData.make}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Model"
          name="model"
          value={formData.model}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Status
          </label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            disabled={isSubmitting}
          >
            {Object.keys(vehicleStatusConfig).map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="pt-6">
        <button
          type="submit"
          className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Onboarding...' : 'Onboard Vehicle'}
        </button>
      </div>
    </form>
  );
};

const InputField = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {label}
    </label>
    <input
      {...props}
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
);

export default VehicleOnboardingForm;
